var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusMath = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.3,0v239.8H0.5v32h239.8v239.8h32V271.7H512v-32H272.2V0H240.3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusMath);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlusMath.e60a34f519bf37ee432ac1d413725669.svg";